module.exports = __webpack_public_path__ + "69df0085.svg";


//////////////////
// WEBPACK FOOTER
// ./images/banner/svgOverlayWide.svg
// module id = 2752
// module chunks = 15